<template>
  <el-dialog
    :title="msgTitle"
    :visible.sync="dialogInfo.flag"
    @close="close"
    :close-on-click-modal="false"
    width="700px"
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :model="newQuestionForm"
      ref="newQuestionForm"
    >
      <el-form-item label="问题类型" prop="questionnaireQuestionType" required>
        <el-radio-group
          v-model="newQuestionForm.questionnaireQuestionType"
          :disabled="isEdit"
        >
          <el-radio :label="0">单选题</el-radio>
          <el-radio :label="1">多选题</el-radio>
          <el-radio :label="2">判断题</el-radio>
          <el-radio :label="3">填空题</el-radio>
          <el-radio :label="4">问答题</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否必答" prop="isMustAnswer" required>
        <el-radio-group v-model="newQuestionForm.isMustAnswer">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="问题题干"
        prop="questionTitle"
        :rules="[
          { required: true, message: '请输入问题题干', trigger: 'blur' },
          { min: 0, max: 500, message: '最多输入500个字', trigger: 'change' },
        ]"
      >
        <el-input
          type="textarea"
          :placeholder="
            newQuestionForm.questionnaireQuestionType == 3
              ? '请输入问题题干，填空处请使用【】代替'
              : '请输入问题题干'
          "
          v-model="newQuestionForm.questionTitle"
        ></el-input>
      </el-form-item>
      <div
        v-if="
          newQuestionForm.questionnaireQuestionType != 3 &&
            newQuestionForm.questionnaireQuestionType != 4
        "
      >
        <el-form-item
          :label="getChnNumChar(i)"
          v-for="(t, i) in newQuestionForm.options"
          :key="i"
          :prop="'options.' + i + '.optionTitle'"
          :rules="[
            {
              required: true,
              message: '选项不能为空',
              trigger: 'blur',
            },
            {
              min: 0,
              max: 300,
              message: '最多输入300个字',
              trigger: 'change',
            },
          ]"
        >
          <el-input
            :placeholder="'请输入' + getChnNumChar(i)"
            v-model="t.optionTitle"
          >
            <el-button
              v-if="i > 1"
              slot="append"
              icon="el-icon-delete"
              @click="deleteChoose(i)"
            ></el-button>
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog-footer">
      <el-button
        type="primary"
        @click="addChoose"
        size="small"
        v-if="
          newQuestionForm.options.length < Max_Qustion &&
            Number(newQuestionForm.questionnaireQuestionType) < 2
        "
        >新增选项</el-button
      >
    </div>
    <div slot="footer">
      <el-button @click="resetAddForm" size="small">重置</el-button>
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" @click="submitAdd" size="small">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { convertToChineseNumeral } from "@/utils/common";
export default {
  components: {},
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      Max_Qustion: 24,
      msgTitle: "新增问题",
      isEdit: false,
      newQuestionForm: {
        questionnaireQuestionType: 0,
        isMustAnswer: 1,
        questionTitle: "",
        options: [{ optionTitle: "" }, { optionTitle: "" }],
      },
    };
  },
  created() {
    this.isEdit = this.dialogInfo.isEdit || false;
    if (this.isEdit) {
      this.msgTitle = "编辑问题";
      this.newQuestionForm = JSON.parse(JSON.stringify(this.dialogInfo.question));
    }
  },
  activated() {},
  computed: {},
  methods: {
    submitAdd() {
      this.$refs["newQuestionForm"].validate((valid) => {
        if (valid) {
          this.$emit("submitAdd", this.newQuestionForm);
        }
      });
      
    },

    // 重置
    resetAddForm() {
      this.newQuestionForm.isMustAnswer = 1;
      this.newQuestionForm.questionTitle = "";
      this.newQuestionForm.options.map((item) => {
        item.optionTitle = "";
      });
    },

    close() {
      this.$emit("close");
    },


    addChoose() {
      let length =
        this.newQuestionForm.options.length;
      if (length < this.Max_Qustion) {
        this.newQuestionForm.options.push({
          optionTitle: "",
        });
      }
    },

    deleteChoose(index) {
      this.newQuestionForm.options.splice(
        index,
        1
      );
    },

    getChnNumChar(num) {
      return  '选项' + convertToChineseNumeral(num + 1);
    },
  },
};
</script>
<style lang="scss" scoped>

.dialog-footer {
  text-align: center;
  margin-top: 10px;
}
</style>
